type Props = {
  text: string;
  tone: 'success' | 'error';
  className?: string;
};

export function AdminActionBanner({ text, tone, className = '' }: Props) {
  const ok = tone === 'success';
  return (
    <p
      className={`text-[10px] px-2 py-1.5 rounded-lg text-center leading-relaxed ${className}`}
      style={{
        background: ok ? 'rgba(72,187,120,0.12)' : 'rgba(252,129,74,0.12)',
        color: ok ? '#68D391' : '#FC814A',
        border: `1px solid ${ok ? 'rgba(72,187,120,0.3)' : 'rgba(252,129,74,0.35)'}`,
      }}
    >
      {text}
    </p>
  );
}
